import { Facebook, Instagram, Linkedin } from "lucide-react";
import { SOCIALS } from "@/data/content";

const ICONS = { linkedin: Linkedin, instagram: Instagram, facebook: Facebook };

export const SocialLinks = ({ className = "" }) => (
  <div data-testid="social-links" className={`flex items-center gap-3 ${className}`}>
    <span className="font-heading text-sm font-bold text-navy">Follow PKR</span>
    {SOCIALS.map(({ id, label, href }) => {
      const Icon = ICONS[id];
      return (
        <a
          key={id}
          data-testid={`social-link-${id}`}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`PKR on ${label}`}
          className="flex h-9 w-9 items-center justify-center bg-navy text-white transition-colors hover:bg-midnight"
        >
          <Icon className="h-4 w-4" />
        </a>
      );
    })}
  </div>
);
